export default __webpack_public_path__ + "static/nitrocam-ca4e886f57fbe642d7803d09438c9c26.svg";